import React from 'react';
import { industries } from '../mock';
import { Building2, Zap, Factory, LineChart, ArrowRight } from 'lucide-react';

const Icons = [Building2, Zap, Factory, LineChart];

export default function Industries() {
  return (
    <section id="industries" className="relative">
      <div className="max-w-[1320px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div className="text-[11.5px] tracking-[0.16em] uppercase text-[#1B6F5E] font-medium">
              Where ESGine® fits
            </div>
            <h2 className="mt-3 font-display text-[40px] lg:text-[56px] leading-[1.02] text-[#0B1F2D]">
              Built for regulated
              <br />
              <span className="italic">jurisdictions.</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pt-3">
            <p className="text-[16.5px] leading-[1.6] text-[#0B1F2D]/70 max-w-[640px]">
              ESGine® is built for organizations subject to one or more of the seven frameworks it supports. If your
              company operates in the EU, US, or UK, you are almost certainly covered.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {industries.map((ind, i) => {
            const Ico = Icons[i];
            return (
              <div
                key={ind.title}
                className="card-lift rounded-2xl border border-[#E8E5DC] bg-white p-8 lg:p-10 flex flex-col"
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 rounded-xl bg-[#0B1F2D] text-[#7BC2B0] flex items-center justify-center">
                    <Ico className="w-5 h-5" />
                  </div>
                  <div className="font-mono-tight text-[11px] text-[#0B1F2D]/45">0{i + 1}</div>
                </div>
                <div className="mt-7 font-display text-[26px] lg:text-[28px] leading-[1.15] text-[#0B1F2D]">
                  {ind.title}
                </div>
                <p className="mt-3 text-[14.5px] leading-[1.6] text-[#0B1F2D]/65">{ind.desc}</p>
                <div className="mt-6 flex flex-wrap gap-1.5">
                  {ind.tags.map((t) => (
                    <span
                      key={t}
                      className="text-[11px] font-mono-tight px-2.5 py-1 rounded-md border border-[#E8E5DC] text-[#0B1F2D]/70 bg-[#FAFAF5]"
                    >
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-dashed border-[#0B1F2D]/20 bg-[#FAFAF5] px-7 py-5">
          <p className="text-[14.5px] text-[#0B1F2D]/75">
            Not sure if ESGine® is a fit? Book a short briefing with our team to discuss your reporting context.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-1.5 text-[13.5px] font-medium text-[#0B1F2D] link-underline"
          >
            Book a briefing <ArrowRight className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </section>
  );
}
